import Vue from 'vue';
import JwtService from '@/common/jwt.service';
import axios from 'axios';
import VueAxios from 'vue-axios';

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  },

  setHeader() {
    Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${JwtService.getToken()}`;
  },
  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, slug = '') {
    if (JwtService.getToken() !== null) {
      this.setHeader();
    } else {
      // TODO ? why did the template have this else here?
    }
    let params = '';
    /* TODO un-underscore-ify
    if (!_.isNaN(slug)) {
      params = '?' + slug
    }
    if (_.isObject(slug)) {
      params = '?' + _.keys(slug).filter(key => (slug[key] != null && slug[key] !== 'null'))
        .map(key => key + '=' + slug[key]).join('&')
    }
    */
    return Vue.axios.get(`${resource}${params}`).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  post(resource, params) {
    if (JwtService.getToken() !== null) {
      this.setHeader();
    }
    return Vue.axios.post(`${resource}`, params);
  },

  postForm(resource, formData) {
    if (JwtService.getToken() !== null) {
      this.setHeader();
    }
    return Vue.axios.post(`${resource}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;
